namespace RedBullMOBILE360.CustomerCare {
    export interface ThreeThreeZeroNotificationExcelImportForm {
        FileName: Serenity.ImageUploadEditor;
    }

    export class ThreeThreeZeroNotificationExcelImportForm extends Serenity.PrefixedContext {
        static formKey = 'CustomerCare.ThreeThreeZeroNotificationExcelImport';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ThreeThreeZeroNotificationExcelImportForm.init)  {
                ThreeThreeZeroNotificationExcelImportForm.init = true;

                var s = Serenity;
                var w0 = s.ImageUploadEditor;

                Q.initFormType(ThreeThreeZeroNotificationExcelImportForm, [
                    'FileName', w0
                ]);
            }
        }
    }
}
